export const initialState = {
  isFetching: false,
  isFetched: false,
  availableWithdrawMoney: 0,
  cacheUpdatedData: null,
  easyBalance: 0,
  error: false,
  errorDownload: false,
  filteredInvestments: [],
  filters: {
    filteredDate: null,
    filteredGroups: 0,
    filteredTypes: [],
    filteredValues: [],
    hasFilters: false,
    size: 0
  },
  fund: {},
  hidePosition: false,
  investmentPortfolio: [],
  investments: [],
  investmentsById: {},
  investmentsByType: {},
  investmentsQuantity: 0,
  isCached: false,
  isFetchedDownload: false,
  isFetchingDownload: false,
  isProjectedBalance: false,
  maturityList: [],
  minMaxInvestmentValues: [],
  navItems: [],
  success: false,
  successDownload: false,
  totalBalance: 0,
  totalInvestments: 0,
  isDelayed: false,
  delayedMessages: {}
}

export const ACTION_TYPES = {
  CUSTODYANDPOSITION_REQUEST: 'CUSTODYANDPOSITION_REQUEST',
  CUSTODYANDPOSITION_SUCCESS: 'CUSTODYANDPOSITION_SUCCESS',
  CUSTODYANDPOSITION_ERROR: 'CUSTODYANDPOSITION_ERROR'
}

export const getCustodyAndPosition = (payload = {}) => ({
  type: ACTION_TYPES.CUSTODYANDPOSITION_REQUEST,
  payload
})

const custodyAndPosition = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTION_TYPES.CUSTODYANDPOSITION_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case ACTION_TYPES.CUSTODYANDPOSITION_SUCCESS:
      return {
        ...state,
        ...payload,
        isFetching: false,
        isFetched: true,
        success: true
      }
    case ACTION_TYPES.CUSTODYANDPOSITION_ERROR:
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        error: true
      }
    default:
      return { ...state }
  }
}

export default custodyAndPosition
